<template>
  <div>
    <nuxt-link v-if="offerTitle" :to="$routerUrl(offersData?.info?.seo_url)"
               class="text-error font-niceone-bold px-4 md:px-0" @click="addEvent">
      {{ offerTitle }}
      <van-icon class="flip-icon" color="#BDBDBD" name="arrow"/>
    </nuxt-link>
    <device-wrapper #default="{ desktop }">
      <div v-if="desktop" class="relative">
        <swiper-wrapper :slides-per-group="1"
                        :slidesPerView="'auto'"
                        :space-between="20"
                        class="!min-w-0 overflow-hidden">
          <template #swiper>
            <swiper-slide v-for="(offer,index) in offersData?.offers" :key="`desktop-offer-list-item-${index}`"
                          class="!w-auto">
              <offer-list-item :index="index" :offer="offer" :offers-list="offersList"/>
            </swiper-slide>
          </template>
        </swiper-wrapper>
      </div>
      <div v-else class="ps-3 overflow-x-auto flex">
        <offer-list-item v-for="(offer,index) in offersData?.offers" :key="`mobile-offer-list-item-${index}`"
                         :index="index"
                         :offer="offer"
                         :offers-list="offersList"/>
      </div>
    </device-wrapper>
  </div>
</template>

<script setup>
import SwiperWrapper from "@/components/common/SwiperWrapper";
import OfferListItem from "@/components/product/offers/OfferListItem";
import {getPDPOffersMutation} from "@/plugins/API/product";
import {useCartStore} from "@/store/cart";
import {track} from "@/composables/useTrackEvent";
import {TRACKERS} from "@/constants/events";

const props = defineProps({
  id: {
    type: String,
    default: 0
  },
  selectedOption: {
    type: Object,
    default: () => {
    }
  },
});

const offersData = ref(null)
const cartStore = useCartStore()
const {count} = storeToRefs(cartStore)
const {data, mutateAsync} = getPDPOffersMutation()

onMounted(() => fetchOffers())

const offerTitle = computed(() => offersData.value?.info?.title)
const offersList = computed(() => data?.value?.offers?.length)
const variantId = computed(() => props?.selectedOption?.defaultOption?.product_option_variant_id || props?.selectedOption?.secondaryOption?.product_option_variant_id || null)

const fetchOffers = async () => {
  try {
    await mutateAsync({product_id: props?.id, variant_id: variantId.value})
    if (data.value) offersData.value = data.value
  } catch (_) {}
}

watch(count, () => fetchOffers())

const addEvent = () => {
  const {info} = toRaw(offersData.value)

  track(TRACKERS.OPEN_BUNDLE_LIST, {
    product_id: props?.id,
    offer_id: info?.offer_id,
    offer_title: info?.title_en
  })
}
</script>